import validate from "/app/node_modules/.pnpm/nuxt@4.1.1_@parcel+watcher@2.5.1_@types+node@24.3.1_@vue+compiler-sfc@3.5.21_db0@0.3.2__2f054457d89499d19c059fd5d88ab17d/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.1.1_@parcel+watcher@2.5.1_@types+node@24.3.1_@vue+compiler-sfc@3.5.21_db0@0.3.2__2f054457d89499d19c059fd5d88ab17d/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}